import React, { createContext, useContext, useState } from 'react'
import { NavContextProps } from './ContentfulNavigation.d'

export const navContextDefaults: NavContextProps = {
  desktopNavHeight: 0,
  heapClasses: null,
  headerHeight: 0,
  headerRef: null,
  isMobileNavOpen: false,
  isOverlayOpen: false,
  isRegionMenuOpen: false,
  localizedEntries: [],
  mobileShowcase: null,
  navigationData: null,
  salesPhoneNumber: null,
  selectedParentMenu: null,
  setDesktopNavHeight: () => {},
  setHeaderHeight: () => {},
  setIsMobileNavOpen: () => {},
  setIsOverlayOpen: () => {},
  setIsRegionMenuOpen: () => {},
  setSelectedParentMenu: () => {},
  showLogin: false,
  showRegionSelector: false,
  showRequestDemo: false,
  showRestaurantSearch: false,
  showSalesInDesktopNav: false,
  showSalesInMobileMenu: false,
  showSalesInMobileNav: false,
  siteId: 1,
  siteRegion: null
}

export const NavContext = createContext<NavContextProps>({
  ...navContextDefaults
})

export const NavContextProvider = ({
  children,
  value
}: {
  children: any
  value?: any
}) => {
  const [desktopNavHeight, setDesktopNavHeight] = useState<number>(
    value?.desktopNavHeight || 0
  )
  const [headerHeight, setHeaderHeight] = useState<number>(
    value?.headerHeight || 0
  )
  const [isMobileNavOpen, setIsMobileNavOpen] = useState<boolean>(
    value?.isMobileNavOpen || false
  )
  const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(
    value?.isOverlayOpen || false
  )
  const [isRegionMenuOpen, setIsRegionMenuOpen] = useState<boolean>(
    value?.isRegionMenuOpen || false
  )
  const [selectedParentMenu, setSelectedParentMenu] = useState<string | null>(
    value?.selectedParentMenu || null
  )

  return (
    <NavContext.Provider
      value={{
        ...value,
        desktopNavHeight,
        headerHeight,
        isMobileNavOpen,
        isOverlayOpen,
        isRegionMenuOpen,
        selectedParentMenu,
        // Allow mock functions for jest testing
        setDesktopNavHeight: value?.setDesktopNavHeight || setDesktopNavHeight,
        setHeaderHeight: value?.setHeaderHeight || setHeaderHeight,
        setIsMobileNavOpen: value?.setIsMobileNavOpen || setIsMobileNavOpen,
        setIsOverlayOpen: value?.setIsOverlayOpen || setIsOverlayOpen,
        setIsRegionMenuOpen: value?.setIsRegionMenuOpen || setIsRegionMenuOpen,
        setSelectedParentMenu:
          value?.setSelectedParentMenu || setSelectedParentMenu
      }}
    >
      {children}
    </NavContext.Provider>
  )
}

export const useNavContext = () => {
  const context = useContext(NavContext)
  // Throw error if context is undefined, but allow this to run if in a Jest test environment
  // Todo - remove this Jest check and add context to the offending tests
  if (!context) {
    if (
      typeof process !== 'undefined' &&
      process.env.JEST_WORKER_ID !== undefined
    ) {
      return {
        ...navContextDefaults
      }
    } else {
      throw new Error('useNavContext must be used within a NavContext')
    }
  }
  return context
}
